import { useEffect, useRef } from "react";

export function useKeyDown(cb: (e: KeyboardEvent) => void, keys: string[], withControlKey: boolean = false) {
    const callback = useRef(cb);

    useEffect(() => {
        callback.current = cb;
    })

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (keys.includes(event.key) && (!withControlKey || event.ctrlKey)) {
                callback.current(event);
            }
        }

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown)
        };
    }, [keys])
}
